/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Warning,
  Spinner,
  Picklist
} from '../'

export class DynamicPicklist extends React.PureComponent {
  render() {
    const { query, field, params, id, defaultValue, placeholder, value, onChange, disabled, inline, symbol, className } = this.props

    return (
      <Query query={query} variables={params} fetchPolicy='network-only'>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner className='slds-is-relative slds-m-left_large' size='x-small' />
          }
          if (error) {
            return (
              <Warning className='slds-m-left_small' iconSize='x-small' inline={true}>
                Failed to load options.
              </Warning>
            )
          }

          let options = data[Object.keys(data)[0]].edges.filter(edge => edge.node.hasOwnProperty(field))
          if (defaultValue) {
            let defaultOption = {
              node: {
                id: '',
                [field]: defaultValue
              }
            }
            options.unshift(defaultOption)
          }

          let valueMatchingOption = options.find(record => record.node.id === value)

          return (
            <Picklist
              id={id}
              options={options.map(record => record.node[field])}
              default={defaultValue}
              placeholder={placeholder}
              symbol={symbol}
              value={valueMatchingOption
                ? valueMatchingOption.node[field]
                : ''
              }
              onChange={value => value === ''
                ? onChange(value)
                : onChange(options.find(record => record.node[field] === value).node.id)
              }
              closeDropdownOnSelect={true}
              inline={inline}
              disabled={disabled || options.length === 0}  // length = 0 if the 'field' prop is not a field in query results
              className={className}
            />
          )
        }}
      </Query>
    )
  }
}

DynamicPicklist.propTypes = {
  query: PropTypes.object.isRequired,  // expects gql tagged string literal
  field: PropTypes.string.isRequired,
  params: PropTypes.object,
  // picklist-specific props:
  id: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

DynamicPicklist.defaultProps = {
  params: {},
  defaultValue: undefined,
  value: undefined,
  disabled: false,
  inline: true,
  symbol: 'chevrondown'
}



// WEBPACK FOOTER //
// ./src/components/dynamic-picklist/index.js